import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-db034684"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "action-modal" }
const _hoisted_2 = { class: "heading-text" }
const _hoisted_3 = {
  key: 0,
  class: "line1"
}
const _hoisted_4 = {
  key: 1,
  class: "line1"
}
const _hoisted_5 = {
  key: 2,
  class: "line1"
}
const _hoisted_6 = {
  key: 3,
  class: "line1"
}
const _hoisted_7 = {
  key: 0,
  class: "body-main"
}
const _hoisted_8 = {
  key: 1,
  class: "file-area"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Uploaded files", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "ml-2" }, "General Trust Money Bank Reconciliation:", -1))
const _hoisted_12 = { class: "file ml-2" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-8" }
const _hoisted_15 = { class: "file-name" }
const _hoisted_16 = { class: "col-4" }
const _hoisted_17 = { class: "file-download" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "ml-2" }, "General Trust Money Overdrawn Ledger:", -1))
const _hoisted_21 = { class: "file ml-2" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-8" }
const _hoisted_24 = { class: "file-name" }
const _hoisted_25 = { class: "col-4" }
const _hoisted_26 = { class: "file-download" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "ml-2" }, "Controlled Money:", -1))
const _hoisted_30 = { class: "file ml-2" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-8" }
const _hoisted_33 = { class: "file-name" }
const _hoisted_34 = { class: "col-4" }
const _hoisted_35 = { class: "file-download" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "ml-2" }, "Investment Money:", -1))
const _hoisted_39 = { class: "file ml-2" }
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "col-8" }
const _hoisted_42 = { class: "file-name" }
const _hoisted_43 = { class: "col-4" }
const _hoisted_44 = { class: "file-download" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = {
  key: 1,
  class: "body-main"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createTextVNode("Comment(s) "),
  /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"open sans","font-size":"0.95rem"} }, "(Optional)")
], -1))
const _hoisted_49 = { class: "textarea_box" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-line" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle mr-2" }),
  /*#__PURE__*/_createElementVNode("div", null, "If you confirm to resubmit Part A, the progress or submission of Part B and EER will be removed.")
], -1))
const _hoisted_51 = {
  key: 2,
  class: "body-main"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createTextVNode("Comment(s) "),
  /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"open sans","font-size":"0.95rem"} }, "(Optional)")
], -1))
const _hoisted_54 = { class: "textarea_box" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-line" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle mr-2" }),
  /*#__PURE__*/_createElementVNode("div", null, "If you confirm to resubmit Part B, the progress or submission of EER will be removed.")
], -1))
const _hoisted_56 = {
  key: 3,
  class: "body-main"
}
const _hoisted_57 = ["disabled"]
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "checkbox-elmt",
  style: {"border":"none"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "checkbox-text" }, "Part A (Applies to all branches)")
], -1))
const _hoisted_59 = ["disabled"]
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "checkbox-elmt",
  style: {"border":"none"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "checkbox-text" }, "Part B")
], -1))
const _hoisted_61 = ["disabled"]
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "checkbox-elmt",
  style: {"border":"none"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "checkbox-text" }, "External Examiner Report")
], -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_64 = { class: "controls mt-4" }
const _hoisted_65 = ["disabled"]
const _hoisted_66 = ["disabled"]

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ModalBox = _resolveComponent("ModalBox")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_ModalBox, {
      onClose: _cache[7] || (_cache[7] = $event => (_ctx.closeModal()))
    }, {
      "header-text": _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.actionType === 'file-attachment')
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "File attachments"))
            : _createCommentVNode("", true),
          (_ctx.actionType === 'resubmit-part-a')
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Part A resubmission"))
            : _createCommentVNode("", true),
          (_ctx.actionType === 'resubmit-part-b')
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Part B resubmission"))
            : _createCommentVNode("", true),
          (_ctx.actionType === 'absolution')
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Not required"))
            : _createCommentVNode("", true)
        ])
      ]),
      body: _withCtx(() => [
        (_ctx.actionType === 'file-attachment')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_ctx.loadingContent)
                ? (_openBlock(), _createBlock(_component_LoadingIndicator, { key: 0 }))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _hoisted_9,
                    _hoisted_10,
                    _createElementVNode("div", null, [
                      _hoisted_11,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileList?.generalTrustMoneyBankReconciliationFiles, (f, i) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("div", _hoisted_15, _toDisplayString(f?.fileName), 1)
                            ]),
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("button", {
                                  class: "btn btn-secondary sml",
                                  onClick: $event => (_ctx.downloadFile(f))
                                }, "Download", 8, _hoisted_18)
                              ])
                            ])
                          ])
                        ]))
                      }), 256)),
                      _hoisted_19,
                      _hoisted_20,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileList?.generalTrustMoneyOverdrawnLedgerFiles, (f, i) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("div", _hoisted_24, _toDisplayString(f?.fileName), 1)
                            ]),
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("div", _hoisted_26, [
                                _createElementVNode("button", {
                                  class: "btn btn-secondary sml",
                                  onClick: $event => (_ctx.downloadFile(f))
                                }, "Download", 8, _hoisted_27)
                              ])
                            ])
                          ])
                        ]))
                      }), 256)),
                      _hoisted_28,
                      _hoisted_29,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileList?.controlledMoneyFiles, (f, i) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("div", _hoisted_33, _toDisplayString(f?.fileName), 1)
                            ]),
                            _createElementVNode("div", _hoisted_34, [
                              _createElementVNode("div", _hoisted_35, [
                                _createElementVNode("button", {
                                  class: "btn btn-secondary sml",
                                  onClick: $event => (_ctx.downloadFile(f))
                                }, "Download", 8, _hoisted_36)
                              ])
                            ])
                          ])
                        ]))
                      }), 256)),
                      _hoisted_37,
                      _hoisted_38,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileList?.investmentMoneyFiles, (f, i) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("div", _hoisted_42, _toDisplayString(f?.fileName), 1)
                            ]),
                            _createElementVNode("div", _hoisted_43, [
                              _createElementVNode("div", _hoisted_44, [
                                _createElementVNode("button", {
                                  class: "btn btn-secondary sml",
                                  onClick: $event => (_ctx.downloadFile(f))
                                }, "Download", 8, _hoisted_45)
                              ])
                            ])
                          ])
                        ]))
                      }), 256))
                    ])
                  ]))
            ]))
          : _createCommentVNode("", true),
        (_ctx.actionType === 'resubmit-part-a')
          ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
              _createElementVNode("div", null, [
                _createTextVNode("Are you sure you want to resubmit Part A for "),
                _createElementVNode("strong", null, _toDisplayString(_ctx.selectedPractice.firmName), 1),
                _createTextVNode(" / "),
                _createElementVNode("strong", null, _toDisplayString(_ctx.selectedPractice.firmId), 1),
                _createTextVNode("? ")
              ]),
              _hoisted_47,
              _hoisted_48,
              _createElementVNode("div", _hoisted_49, [
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.comments) = $event)),
                  style: {"border":"1px solid #aaa","height":"130px","resize":"vertical","width":"100%"},
                  maxlength: 5000,
                  placeholder: "Enter comments"
                }, null, 512), [
                  [_vModelText, _ctx.comments]
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["footnote", [_ctx.comments.length === 5000 ? 'full' : '']])
                }, _toDisplayString(_ctx.comments.length || 0) + "/5000 characters ", 3)
              ]),
              _hoisted_50
            ]))
          : _createCommentVNode("", true),
        (_ctx.actionType === 'resubmit-part-b')
          ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
              _createElementVNode("div", null, [
                _createTextVNode("Are you sure you want to resubmit Part B for "),
                _createElementVNode("strong", null, _toDisplayString(_ctx.practiceName), 1),
                _createTextVNode(" / "),
                _createElementVNode("strong", null, _toDisplayString(_ctx.practice.practice?.firmId), 1),
                _createTextVNode("? ")
              ]),
              _hoisted_52,
              _hoisted_53,
              _createElementVNode("div", _hoisted_54, [
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.comments) = $event)),
                  style: {"border":"1px solid #aaa","height":"130px","resize":"vertical","width":"100%"},
                  maxlength: 5000,
                  placeholder: "Enter comments"
                }, null, 512), [
                  [_vModelText, _ctx.comments]
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["footnote", [_ctx.comments.length === 5000 ? 'full' : '']])
                }, _toDisplayString(_ctx.comments.length || 0) + "/5000 characters ", 3)
              ]),
              _hoisted_55
            ]))
          : _createCommentVNode("", true),
        (_ctx.actionType === 'absolution')
          ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
              _createElementVNode("h4", null, "Compliance year: " + _toDisplayString(_ctx.practice.complianceYear?.name), 1),
              _createElementVNode("label", {
                class: _normalizeClass(["checkbox-button", _ctx.isDisabledPartA ? 'disabled':''])
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.isAbsolvedPartA) = $event)),
                  disabled: _ctx.isDisabledPartA
                }, null, 8, _hoisted_57), [
                  [_vModelCheckbox, _ctx.isAbsolvedPartA]
                ]),
                _hoisted_58
              ], 2),
              _createElementVNode("label", {
                class: _normalizeClass(["checkbox-button", _ctx.isDisabledPartB ? 'disabled':''])
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.isAbsolvedPartB) = $event)),
                  disabled: _ctx.isDisabledPartB
                }, null, 8, _hoisted_59), [
                  [_vModelCheckbox, _ctx.isAbsolvedPartB]
                ]),
                _hoisted_60
              ], 2),
              _createElementVNode("label", {
                class: _normalizeClass(["checkbox-button", _ctx.isDisabledEeReport ? 'disabled':''])
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.isAbsolvedEeReport) = $event)),
                  disabled: _ctx.isDisabledEeReport
                }, null, 8, _hoisted_61), [
                  [_vModelCheckbox, _ctx.isAbsolvedEeReport]
                ]),
                _hoisted_62
              ], 2)
            ]))
          : _createCommentVNode("", true)
      ]),
      footer: _withCtx(() => [
        _hoisted_63,
        _createElementVNode("div", _hoisted_64, [
          (_ctx.isSaving)
            ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
                key: 0,
                loadingText: _ctx.savingText,
                class: "mr-4"
              }, null, 8, ["loadingText"]))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "btn btn-default",
            onClick: _cache[5] || (_cache[5] = _withModifiers($event => (_ctx.closeModal()), ["prevent","stop"])),
            disabled: _ctx.isSaving
          }, " Close ", 8, _hoisted_65),
          (_ctx.showConfirmButton)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "btn btn-primary",
                onClick: _cache[6] || (_cache[6] = _withModifiers($event => (_ctx.confirm(_ctx.actionType)), ["prevent","stop"])),
                disabled: _ctx.isSaving
              }, " Confirm ", 8, _hoisted_66))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    })
  ]))
}